import * as React from "react";
const SvgTemperature24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "black",
        viewBox: "0 0 24 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M11.5 4C11.7761 4 12 4.22386 12 4.5V15.0498C13.1411 15.2814 14 16.2905 14 17.5C14 18.8807 12.8807 20 11.5 20C10.1193 20 9 18.8807 9 17.5C9 16.2905 9.85886 15.2814 11 15.0498V4.5C11 4.22386 11.2239 4 11.5 4Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11.5 1C13.433 1 15 2.567 15 4.5V13.2588C16.2212 14.2673 17 15.7923 17 17.5C17 20.5376 14.5376 23 11.5 23C8.46243 23 6 20.5376 6 17.5C6 15.7923 6.77875 14.2673 8 13.2588V4.5C8 2.567 9.567 1 11.5 1ZM11.5 3C10.6716 3 10 3.67157 10 4.5V14.3359C8.81734 14.8976 8 16.1037 8 17.5C8 19.433 9.567 21 11.5 21C13.433 21 15 19.433 15 17.5C15 16.1037 14.1827 14.8976 13 14.3359V4.5C13 3.67157 12.3284 3 11.5 3Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M20 12H16V11H20V12Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M18 10H16V9H18V10Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M20 8H16V7H20V8Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M18 6H16V5H18V6Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M20 4H16V3H20V4Z"
    })
  );
export default SvgTemperature24Px;
